// extracted by mini-css-extract-plugin
export var card = "card-module--card--Z2mcd";
export var cardContainer = "card-module--card-container--1hsJR";
export var cardThumb = "card-module--card-thumb--3lqOQ";
export var cardInformation = "card-module--card-information--1qiJZ";
export var cardTitle = "card-module--card-title--1kzqJ";
export var cardExpect = "card-module--card-expect--3NUC-";
export var cardTime = "card-module--card-time--3_Wpv";